import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

export const includeChinese = (str) => {
  return /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/.test(
    str,
  );
};

export const validateEmail = (value, opt, errMsg, errMsgBlank) => {
  if (!value && !opt) return errMsgBlank || 'input.empty_field';
  if (value && includeChinese(value)) return 'input.incorrect_format';
  if (
    value &&
    !/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(
      value,
    )
  )
    return errMsg || 'input.incorrect_format';
  return '';
};

export const validateEmailV2 = (value, opt, errMsg, errMsgBlank) => {
  const email = value || {};
  if (!email.isCorrect) {
    return 'ERROR';
  }
  return '';
};

export const validateDate = (value, opt, min, max, minMsg, maxMsg, errMsg) => {
  if (!value && !opt) return 'input.empty_field';
  if (value && !/^(\d{4})-(\d{1,2})-(\d{1,2})$/.test(value))
    return errMsg || 'input.incorrect_format';
  if (
    value &&
    min &&
    new Date(value).setHours(0, 0, 0, 0) < new Date(min).setHours(0, 0, 0, 0)
  )
    return minMsg || errMsg || 'input.incorrect_format';
  if (
    value &&
    max &&
    new Date(value).setHours(0, 0, 0, 0) > new Date(max).setHours(0, 0, 0, 0)
  )
    return maxMsg || errMsg || 'input.incorrect_format';
  return '';
};

export const validateFormatInput = (
  value,
  validateRule,
  opt,
  min,
  max,
  minMsg,
  maxMsg,
  errMsg,
) => {
  const re = validateRule ? new RegExp(validateRule) : null;
  if (!value && !opt) return 'input.empty_field';
  if (value && /[\uff00-\uffff]/.test(value)) return 'input.incorrect_format';
  if (value && min && value.length < min)
    return minMsg || errMsg || 'input.incorrect_format';
  if (value && max && value.length > max)
    return maxMsg || errMsg || 'input.incorrect_format';
  if (value && re && !re.test(value)) return errMsg || 'input.incorrect_format';
  return '';
};

export const validatePolicyNo = (value) => {
  return validateFormatInput(
    value,
    /^[a-zA-Z0-9-]*$/,
    null,
    10,
    10,
    null,
    null,
    null,
  );
};
export const validateCertNo = (value) => {
  return validateFormatInput(
    value,
    /^[a-zA-Z0-9-]*$/,
    null,
    1,
    7,
    null,
    null,
    null,
  );
};
export const validateDigit = (value) => {
  return validateFormatInput(
    value,
    /^[a-zA-Z0-9-]*$/,
    null,
    1,
    2,
    null,
    null,
    null,
  );
};
export const validateDOB = (value) => {
  return validateDOBInput(value);
};
export const validateMembershipNo = (value) => {
  return validateFormatInput(
    value,
    /^[e0-9-]*$/,
    null,
    8,
    15,
    null,
    null,
    null,
  );
};
export const validateHKID = (value) => {
  return validateFormatInput(
    value,
    '^(?! )[a-zA-Z0-9_ ]*$',
    null,
    7,
    8,
    null,
    null,
    'signUp.individual.errorFormat.hkID',
  );
};
export const validatePRCID = (value) => {
  return validateFormatInput(
    value,
    '^(?! )[a-zA-Z0-9_ ]*$',
    null,
    15,
    18,
    null,
    null,
    'signUp.individual.errorFormat.prcid',
  );
};
export const validationEmail = (value) => {
  return validateEmail(value, null, 'signUp.email.invalid');
};
export const validateCardNoMain = (value) => {
  return validateFormatInput(
    value,
    /^[a-zA-Z0-9-]*$/,
    null,
    1,
    7,
    null,
    null,
    null,
  );
};
export const validateCardNoSub = (value) => {
  return validateFormatInput(
    value,
    /^[a-zA-Z0-9-]*$/,
    null,
    1,
    2,
    null,
    null,
    null,
  );
};

export const validateDOBInput = (value) => {
  let year = '';
  let month = '';
  let date = '';
  let errorMsgDOB = '';
  if (value) {
    ({ year, month, date, errorMsgDOB } = value);
  } else {
    return 'input.empty_field';
  }
  if (year && month && date && !errorMsgDOB) {
    return '';
  }
  return errorMsgDOB;
};

export const validatePassportNo = (value) => {
  return validateFormatInput(
    value,
    /^[a-zA-Z0-9]*$/,
    null,
    null,
    null,
    null,
    null,
    null,
  );
};

export const validateCheckbox = (value, opt, errMsg) => {
  if (!value && !opt)
    return errMsg || <FormattedMessage id="input.empty_field" />;
  return '';
};

export const validateAlphabet = (
  value,
  opt,
  min,
  max,
  minMsg,
  maxMsg,
  errMsg,
) => {
  if (!value && !opt) return 'input.empty_field';
  if (value && /[\uff00-\uffff]/.test(value)) return 'input.incorrect_format';
  if (value && min && value.length < min)
    return minMsg || errMsg || 'input.incorrect_format';
  if (value && max && value.length > max)
    return maxMsg || errMsg || 'input.incorrect_format';
  if (value && !/^[A-z]+$/.test(value))
    return errMsg || 'input.incorrect_format';
  return '';
};

export const validateNumber = (value, opt, max, digit, errMsg, errMsgBlank) => {
  const maxValue = max || digit;
  if (!value && !opt) return errMsgBlank || 'input.empty_field';
  if (value && /[\uff00-\uffff]/.test(value)) return 'input.incorrect_format';
  if (value && /\D/.test(value)) return errMsg || 'input.incorrect_format';
  if (value && value.length < digit) return errMsg || 'input.incorrect_format';
  if (value && value.length > maxValue)
    return errMsg || 'input.incorrect_format';
  return '';
};

export const validateAlphaNumeric = (
  value,
  max,
  digit,
  errMsg,
  errMsgBlank,
) => {
  const maxValue = max || digit;
  if (!value) {
    return errMsgBlank || 'input.empty_field';
  }
  if (value && /[\uff00-\uffff]/.test(value)) {
    return 'input.incorrect_format';
  }
  if (!/^[a-z0-9]+$/i.test(value)) {
    return errMsg || 'input.incorrect_format';
  }
  if (digit && value.length < digit) {
    return errMsg || 'input.incorrect_format';
  }
  if (maxValue && value.length > maxValue) {
    return errMsg || 'input.incorrect_format';
  }
  return '';
};

export const sequenceValidatorCheck = (s) => {
  // Check for sequential numerical characters
  // Should not allow more than six number sequence
  // eg: 1234567 is invalid
  // eg: 1234578 is valid
  // Code iterate through each number checking it with the next number (upto six)
  for (let i = 0; i < s.length; i++) {
    if (
      +s[i + 1] === +s[i] + 1 &&
      +s[i + 2] === +s[i] + 2 &&
      +s[+i + 3] === +s[i] + 3 &&
      +s[+i + 4] === +s[i] + 4 &&
      +s[+i + 5] === +s[i] + 5
    ) {
      return false;
    }
  }
  // Check for sequential alphabetical characters
  // Should not allow more than six alphabetical sequence
  // eg: abcdefgh is invalid
  // eg: abcdfghi is valid
  // Code iterate through each alphabet checking it with the next alphabet (upto six)
  const s1 = s.toUpperCase();
  for (let i = 0; i < s1.length; i++) {
    if (
      String.fromCharCode(s1.charCodeAt(i) + 1) === s1[+i + 1] &&
      String.fromCharCode(s1.charCodeAt(i) + 2) === s1[+i + 2] &&
      String.fromCharCode(s1.charCodeAt(i) + 3) === s1[+i + 3] &&
      String.fromCharCode(s1.charCodeAt(i) + 4) === s1[+i + 4] &&
      String.fromCharCode(s1.charCodeAt(i) + 5) === s1[+i + 5]
    ) {
      return false;
    }
  }
  return true;
};

export const passwordRequirements = (string) => {
  const obj = {
    isLength: string.length > 7 && string.length < 17,
    checkRepetition: /.*((.)\2{2}?(?!\2))/g.test(string),
    checkSpace: /(.*\s)/g.test(string),
    checkCharacter: 0,
    checkLowercase: /(.*[a-z])/g.test(string),
    checkUppercase: /(.*[A-Z])/g.test(string),
    checkDigit: /(.*\d)/g.test(string),
    checkSpecial: /(.*_|[^\w])/g.test(string),
    checkSequence: !sequenceValidatorCheck(string),
  };
  /(.*[A-Z])/g.test(string) ? obj.checkCharacter++ : null;
  /(.*[a-z])/g.test(string) ? obj.checkCharacter++ : null;
  /(.*\d)/g.test(string) ? obj.checkCharacter++ : null;
  /(.*_|[^\w])/g.test(string) ? obj.checkCharacter++ : null;
  return obj;
};

export const validatePassword = (
  value,
  opt,
  min,
  max,
  minMsg,
  maxMsg,
  errMsg,
) => {
  let validationRequirements = {};
  if (value) {
    validationRequirements = passwordRequirements(value);
  }
  if (!value && !opt) return 'input.empty_field';
  if (value && /[\uff00-\uffff]/.test(value)) return 'input.incorrect_format';
  if (value && min && value.length < min)
    return minMsg || errMsg || 'input.incorrect_length';
  if (value && max && value.length > max)
    return minMsg || errMsg || 'input.incorrect_length';
  if (value && validationRequirements.checkSpace)
    return maxMsg || errMsg || 'input.incorrect_space';
  if (value && validationRequirements.checkRepetition)
    return maxMsg || errMsg || 'input.incorrect_repetition';
  if (
    value &&
    validationRequirements.checkCharacter < 3 &&
    !validationRequirements.checkLowercase
  )
    return maxMsg || errMsg || 'input.incorrect_lower';
  if (
    value &&
    validationRequirements.checkCharacter < 3 &&
    !validationRequirements.checkDigit
  )
    return maxMsg || errMsg || 'input.incorrect_digit';
  if (
    value &&
    validationRequirements.checkCharacter < 3 &&
    !validationRequirements.checkUppercase
  )
    return maxMsg || errMsg || 'input.incorrect_upper';
  if (value && validationRequirements.checkSequence)
    return errMsg || 'input.incorrect_sequence';
  return '';
};

export const maxLength = (max) => (value) => {
  if (value && value.length === max) {
    return value;
  }
  return value.slice(0, max);
};

export const integerNumberInMaxLength = (max) => (value) => {
  const reg = /^-?(0|[1-9][0-9]*)?$/;
  let result = value;
  if (!reg.test(value.charAt(value.length - 1))) {
    result = value.slice(0, value.length - 1);
  }
  if (result && result.length === max) {
    return result;
  }

  return result.slice(0, max);
};

export const maxLengthUpper = (max) => (value) => {
  if (value && value.length === max) {
    return value.toUpperCase();
  }
  return value.slice(0, max).toUpperCase();
};

export const validateRetypePassword = (value, password) => {
  if (!value) return 'input.empty_field';
  if (value && /[\uff00-\uffff]/.test(value)) return 'input.incorrect_format';
  if (value !== password) return 'input.password.not_match';
  return '';
};

export const validateChinaId = (id) => {
  const format =
    /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  if (!format.test(id)) {
    return false;
  }
  const year = id.substr(6, 4);
  const month = id.substr(10, 2);
  const date = id.substr(12, 2);
  const time = Date.parse(`${month}-${date}-${year}`);
  const nowTime = Date.parse(new Date());
  const dates = new Date(year, month, 0).getDate();
  if (time > nowTime || date > dates) {
    return false;
  }
  const c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const b = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  const idArray = id.split('');
  let sum = 0;
  for (let k = 0; k < 17; k++) {
    sum += parseInt(idArray[k], 10) * parseInt(c[k], 10);
  }
  if (idArray[17].toUpperCase() !== b[sum % 11].toUpperCase()) {
    return false;
  }
  return true;
};

const convertHKIdIChar = (char) => {
  if (char.match('^[A-Z]*$')) {
    return char.charCodeAt() - 55;
  }
  return char;
};

export const validateHKid = (hkId, checkDight) => {
  const isStartWithDoubleAlphabet = hkId[0] >= 'A' && hkId[1] >= 'A';
  let sum = isStartWithDoubleAlphabet ? 0 : 58 * 9;

  const fullHkId = `${hkId}${checkDight}`;
  if (!fullHkId) return false;
  fullHkId.split('').forEach((item, index) => {
    sum += convertHKIdIChar(item) * (fullHkId.length - index);
  });
  const remainder = sum % 11;
  if (remainder === 0) {
    return true;
  }

  if (remainder > 0) {
    const diff = 11 - remainder;
    if (diff === 10) {
      if (checkDight === 'A') {
        return true;
      }
    }
  }
  return false;
};

export const validateChinaIDForm = (values) => {
  let error = null;
  const errorMsg = 'signUp.individual.errorFormat.prcid';
  const basicV = validateFormatInput(
    values.prcId,
    /^[0-9]*X?$/,
    null,
    1,
    19,
    null,
    null,
    errorMsg,
  );
  if (basicV) {
    error = { prcId: basicV };
  }
  return error;
};

export const validateHKidForm = (values) => {
  let error = null;
  const errorMsg = 'signUp.individual.errorFormat.hkID';
  const basicV = validateFormatInput(
    values.hkId,
    /^[a-zA-Z0-9-]*$/,
    null,
    7,
    8,
    null,
    null,
    errorMsg,
  );
  if (basicV) {
    error = { hkId: basicV };
  } else if (
    values.hkId &&
    values.checkDigit &&
    !validateHKid(values.hkId, values.checkDigit)
  ) {
    error = {
      hkId: errorMsg,
      checkDigit: 'common.blank',
    };
  }
  return error;
};

// check for styelsheet HKID component
export const validateHKidFormV2 = (values = {}) => {
  let error = null;
  const hkId = values.hkId || {};
  if (!hkId.isCorrect) {
    error = { hkId: 'ERROR' };
  }
  return error;
};

export const validateDateV2 = (year, month, date) => {
  if (!year) return 'input.empty_year_field';
  if (!month) return 'input.empty_month_field';
  if (!date) return 'input.empty_date_field';
  const momentObj = moment(`${year}${month}${date}`, 'YYYYMMDD');
  if (!momentObj.isValid()) {
    return 'emma.input.date.invalid';
  }

  return '';
};

export const validateDateOfBirth = (
  year,
  month,
  date,
  isCheckValidAge = true,
  minAge = 18,
) => {
  const errStr = validateDateV2(year, month, date);

  if (errStr) {
    return errStr;
  }

  const dob = moment(`${year}${month}${date}`, 'YYYYMMDD');
  if (isCheckValidAge) {
    const age = moment().diff(dob, 'years');
    if (age < minAge) {
      return 'emma.retrieve-account.setup.dob.lower-than-18';
    }
  }
  return '';
};

export const normalizeEmail = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/\s+/, '');
  return onlyNums;
};

/**
 * Check this mobile number is avaliable
 * @param {string} mobileStr numobile number
 */
export const mobileAvaliable = (mobileStr) => {
  if (mobileStr.length > 13) {
    return false;
  }
  if (mobileStr.length === 13) {
    if (!mobileStr.startsWith('86')) {
      return false;
    }
  }
  if (mobileStr.length === 12) {
    if (!mobileStr.startsWith('886')) {
      return false;
    }
  }
  if (mobileStr.length === 11) {
    if (!/^852|^853|^1/.test(mobileStr)) {
      return false;
    }
  }
  if (mobileStr.length === 10 && !mobileStr.startsWith('09')) {
    return false;
  }
  if (mobileStr.length === 9 && !mobileStr.startsWith('9')) {
    return false;
  }
  if (mobileStr.length < 8) {
    return false;
  }
  return true;
};

/**
 * Check whether exists avaliable country code for this mobile
 * @param {string} mobileStr mobile number string
 * @param {object} countryCodes country code avaliable, format like {86: 'Y', 852: 'Y'}
 */
export const countryCodeAvaliable = (mobileStr, countryCodes) => {
  if (!mobileStr) return false;
  if (
    mobileStr.startsWith('852') &&
    mobileStr.length === 11 &&
    countryCodes[852] === 'Y'
  ) {
    return false;
  }
  if (
    mobileStr.startsWith('853') &&
    mobileStr.length === 11 &&
    countryCodes[853] === 'Y'
  ) {
    return false;
  }
  if (
    ((mobileStr.length === 11 && mobileStr.startsWith('1')) ||
      (mobileStr.startsWith('86') && mobileStr.length === 13)) &&
    countryCodes[86] === 'Y'
  ) {
    return false;
  }
  if (
    mobileStr.startsWith('886') &&
    mobileStr.length === 12 &&
    countryCodes[886] === 'Y'
  ) {
    return false;
  }
  if (
    mobileStr.startsWith('09') &&
    mobileStr.length === 10 &&
    countryCodes[886] === 'Y'
  ) {
    return false;
  }
  if (
    mobileStr.startsWith('9') &&
    mobileStr.length === 9 &&
    countryCodes[886] === 'Y'
  ) {
    return false;
  }
  let countryCodeAvas = Object.entries(countryCodes);
  if (mobileStr.length === 8) {
    if (countryCodes[852] === 'Y' && countryCodes[853] === 'Y') {
      return false;
    }
    countryCodeAvas = countryCodeAvas.filter((c) => c[0] !== '86');
  }
  return (
    countryCodeAvas.length > 0 &&
    countryCodeAvas.find((c) => c[1] === 'N') !== undefined
  );
};

/**
 * Check if no one avaliable name in this name list
 * @param {object} userNames user name list, format like [{'861*****1234': {k: number1, v: {86: 'Y', 852: 'N'}}, {'test******@*****com: {k: 'address1', v: 'Y'}}]
 */
export const namesNoAvaliable = (userNames) => {
  const avas = userNames.map((nameObj) => {
    const nameArr = Object.entries(nameObj)[0];
    if (nameArr[0].indexOf('.') > -1 && nameArr[1].v === 'N') {
      return 1;
    }
    return mobileAvaliable(nameArr[0]) &&
      countryCodeAvaliable(nameArr[0], nameArr[1].v)
      ? 1
      : 0;
  });
  return avas.indexOf(1) === -1;
};
